import * as Sentry from "@sentry/react";
import { initTelemetry } from "./telemetry.ts";

Sentry.init({
  dsn: "https://29b1860ff8e2f2414854a02dfdb360f7@sentry.variation99.com/4",
  // The dev server (and the stubbed-fetch harnesses run on it) would report
  // into production's issues.
  enabled: import.meta.env.PROD,
  tracesSampleRate: 0.05,
});

// The TV host serves TV-shared micro apps to anonymous screens and routes
// only `/api/v1/tv` to the backend, so the rest of Vayken (and its telemetry
// endpoint) does not exist there. `dash.` is its name before vayken.app.
const isTvHost = /^(tv|dash)\./.test(window.location.hostname);

if (!isTvHost) initTelemetry();

import CssBaseline from "@mui/material/CssBaseline";
import InitColorSchemeScript from "@mui/material/InitColorSchemeScript";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import TvApp, { leaveLegacyTvHost } from "./pages/tv/TvApp.tsx";
import { queryClient } from "./queryClient.ts";
import theme from "./theme.ts";

// A TV on the old host navigates away; nothing to render meanwhile.
if (!(isTvHost && leaveLegacyTvHost())) {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <ThemeProvider theme={theme} defaultMode="system">
        <InitColorSchemeScript defaultMode="system" />
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            {isTvHost ? <TvApp /> : <App />}
          </BrowserRouter>
          <Toaster
            position="bottom-center"
            toastOptions={{
              style: {
                background: "var(--mui-palette-background-paper)",
                color: "var(--mui-palette-text-primary)",
              },
            }}
          />
        </QueryClientProvider>
      </ThemeProvider>
    </StrictMode>,
  );
}
